import { useExpertProfileContext } from "../../../expert";
import { getCurrentPortal } from "../../utils/PortalHelper";
export const usePortalRoutes = () => {
  const {
    canUserAccess
  } = useExpertProfileContext();
  const getAuthorisedDestinationRoute = navItems => {
    const portal = getCurrentPortal();
    let destinationRoute = null;
    let doesUserHaveAccessToDestinationURL = false;

    //here we are seeing if a user has access to the default destination URL
    //if they don't we need to find the next path they do have access to
    navItems.map(item => {
      if (item.path === `/${portal.destinationRoute}`) {
        doesUserHaveAccessToDestinationURL = canUserAccess(item.policy);
      } else {
        //item text is the name of the nav item
        //we only want the user to go to a page that has a nav item
        if (!destinationRoute && item.text && canUserAccess(item.policy)) {
          //get rid of "/"
          if (item.path) {
            destinationRoute = item.path.substring(1);
          } else {
            const child = item.childRoutes.find(cr => cr.path !== null);
            if (child.path) {
              destinationRoute = child.path.substring(1);
            }
          }
        }
      }
    });
    if (doesUserHaveAccessToDestinationURL) {
      destinationRoute = portal.destinationRoute;
    }
    return destinationRoute;
  };
  return {
    getAuthorisedDestinationRoute,
    canUserAccess
  };
};